import * as React from 'react';
import cx from 'classnames';
import marked from 'marked';
import genUniqueId from 'utils/uniqueId';
import DeferredContent from './DeferredContent/DeferredContent';
import styles from './ContentGenerator.css';
function renderCell(row, header) {
    return header
        .filter(val => row.hasOwnProperty(val))
        .map(content => {
        return (<td key={genUniqueId()} className={styles['table-content-cell']}>
					{row[content]}
				</td>);
    });
}
function renderTableContent(tableItem, header) {
    if (tableItem.data instanceof Array) {
        return tableItem.data.map(row => {
            return (<tr key={genUniqueId()} className={styles['table-content']}>
					{renderCell(row, header)}
				</tr>);
        });
    }
}
function renderTableHeader(header) {
    const headerCells = header.map(title => {
        return (<th key={genUniqueId()} className={styles['table-header-cell']}>
				{title}
			</th>);
    });
    return <tr className={styles['table-header']}>{headerCells}</tr>;
}
function renderTable(tableItem) {
    if (!(tableItem.data instanceof Array))
        return;
    const header = Object.keys(tableItem.data[0]);
    return (<table key={genUniqueId()} className={cx(styles['table'], tableItem.className)}>
			<thead>{renderTableHeader(header)}</thead>
			<tbody>{renderTableContent(tableItem, header)}</tbody>
		</table>);
}
function renderMarkdown(markDownItem) {
    if (typeof markDownItem.data !== 'string') {
        return;
    }
    return (<div key={genUniqueId()} className={cx(styles['markdown'], markDownItem.className)} dangerouslySetInnerHTML={{ __html: marked(markDownItem.data) }}/>);
}
function renderInIframe(iframeParams) {
    if (typeof iframeParams.data !== 'string') {
        return;
    }
    return <iframe key={genUniqueId()} className={styles['frame-view']} src={iframeParams.data}/>;
}
function renderContent(config) {
    return config.map(item => {
        switch (item.type) {
            case 'markdown':
                return renderMarkdown(item);
            case 'table':
                return renderTable(item);
            case 'deferred':
                return (<DeferredContent url={item.data} key={genUniqueId()} requestToPayzippy={item.requestToPayzippy} responseKey={item.responseKey}/>);
            case 'iframe':
                return renderInIframe(item);
            default:
                return;
        }
    });
}
export default function ContentGenerator({ config, className }) {
    return <div className={cx(styles['tooltip-content'], className)}>{renderContent(config)}</div>;
}
export function CustomMarkdownRenderer(props) {
    const Renderer = new marked.Renderer();
    Renderer.paragraph = function (text) {
        return `${text}\n`;
    };
    marked.setOptions({
        renderer: Renderer
    });
    return <span className={cx(styles['markdown'])} dangerouslySetInnerHTML={{ __html: marked(props.data) }}/>;
}
